import { contains, makeFilter, mergeFilters } from '@/utils/dynamic'

export default {
  id: 'RFQ3sParts',
  isAutoLoad: false,
  sortable: {
    field: 'quoteDate',
    order: 'desc'
  },
  mode: {
    isModalNew: false,
    isModalEditing: true
  },
  store: {
    get: {
      url: 'RFQ3s/GetAllDynamic',
      selected: [
        'id', 'id as rfq3ID', 'quoteDate', 'stockID', 'rfq.id as rfqID', 'rfqid',
        'rfq.BAXEmployeeID', 'rfq.BAXEmployee.name as employeeName', 'rfq.customerCompany.name as companyName',
        'qty', 'condition.title as conditionTitle', 'price', 'currency.title as currencyTitle', 'supplyDate',
        'remarks', 'partSN', 'exchangeCoreValue', 'exchangeCoreValueCurrency.title as exchangeCoreValueCurrencyTitle',
        '(chosen==true) ? rfq.po : null as po'],
      filters: 'rfq.rfqTypeID!=4&&rfq.rfqTypeID!=5'
    },
    create: {
      url: 'RFQ3s/Create'
    },
    patch: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'RFQ3s/Patch/${data.id}'
    },
    delete: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'RFQ3s/Delete/${data.id}',
      modal: {
        msgDataKey: 'rfqid'
      }
    }
  },
  header: {
    isVisible: false
  },
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'rfqid',
        options: {
          valueTemplate: (data) => {
            return mergeFilters(
              makeFilter(['rfqid', 'rfq.po', 'partSN'], data.value, contains)
            ).join('&&')
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('search')}",
          styles: {
            maxWidth: '15rem',
            minWidth: '15rem'
          }
        }
      },
      {
        type: 'selectautocomplete',
        field: 'rfq.customerCompanyID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('company')}",
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          templateFilter: 'name.StartsWith("${data.search}")',
          dataSource: {
            url: 'Companies/GetAllDynamic',
            selected: 'id,name',
            take: 50
          },
          option: {
            label: 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          styles: {
            maxWidth: '20rem'
          }
        }
      },
      {
        type: 'datemultiple',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('tag-date')}",
        field: 'rfq.entryDate',
        options: {
          styles: {
            maxWidth: '21rem'
          },
          tabs: [0, 2, 3],
          classes: 'qi-filter-field'
        }
      },
      {
        type: 'select',
        field: 'rfq.BAXEmployee.id',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('employee')}",
        options: {
          dataSource: 'Employees/GetAllDynamic?select=id,name&filter=isActive==true',
          option: {
            label: 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          styles: {
            maxWidth: '15rem'
          }
        }
      }
    ]
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('company')}",
      field: 'companyName',
      sortable: {
        custom: 'rfq.customerCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('qty')}",
      field: 'qty'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('condition')}",
      field: 'conditionTitle',
      sortable: {
        custom: 'condition.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('price')}",
      field: 'price'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('currency')}",
      field: 'currencyTitle',
      sortable: {
        custom: 'currency.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('supply-date')}",
      field: 'supplyDate'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('po')}",
      field: 'po',
      sortable: {
        custom: 'rfq.po'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('bax-employee')}",
      field: 'employeeName',
      sortable: {
        custom: 'rfq.BAXEmployee.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('part-sn')}",
      field: 'partSN'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('quote-date')}",
      field: 'quoteDate',
      template: 'date'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('remarks')}",
      field: 'remarks'
    }
  ],
  rowControls: {
    right: {
      classes: 'controls-inline',
      controls: [
        'edit',
        {
          type: 'custom',
          isVisible: false
        }
      ]
    }
  }
}
